import { render, staticRenderFns } from "./base.vue?vue&type=template&id=feec1270&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=feec1270&prod&lang=scss&scoped=true"
import style1 from "./base.vue?vue&type=style&index=1&id=feec1270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec1270",
  null
  
)

export default component.exports